import { ParentModule } from './../../../A2-utils/ParentClass/parent-module';
import { Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { constant } from '../../../../app.constants';
import { Observable } from 'rxjs';
import { CallTypeInterface } from '../../../../core/interfaces/call-type.interface';
import { UsersService } from '../../../users/users.service';
import { DriverService } from '../../../../core/services/driver.service';
import { DepotService } from '../../../../core/services/depot.service';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import { ReservationService } from 'app/pages/trip-reservations/reservations.service';
import { ReservationNoteService } from 'app/pages/trip-reservations/reservation-notes/reservation-note.service';
import { NoteTypeEnum } from 'app/core/enums/note-type.enum';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { IvrStatusEnum } from 'app/core/enums/reminders.enum';

@Component({
  selector: 'app-rider-information',
  templateUrl: './rider-information.component.html',
  styleUrls: ['./rider-information.component.scss']
})
export class RiderInformationComponent extends ParentModule implements OnInit, OnDestroy {

  @Input() riderInformationForm: FormGroup;
  @Input() callTypes: Observable<CallTypeInterface[]>;
  @Output() reload? = new EventEmitter<boolean>();
  @Input() actionsComp: any;
  @ViewChild('ridermodal') ridermodal: T2CardComponent;
  titleRider = 'Exclude Providers';
  optionNone = null;
  permissioSsn = {showSsn: false, updateSsn: false};
  protected selectCallTypes: CallTypeInterface[];
  protected maskSSN = constant.MASK_SSN;
  protected maskDate = constant.MASK_DOB;
  protected maskMi = constant.MASK_MI;
  protected maskPhone =  constant.MASK_PHONE;
  protected selectProviders = [];
  protected selectDrivers = [];
  protected selectDepots = [];
  private arraySubscriptions = [];
  private providerId: number;
  public riderId: number;
  public members = [];

  constructor(
    private userService: UsersService,
    private _driverService: DriverService,
    private _depotService: DepotService,
    protected Inject: Injector,
    protected newReservationService: ReservationService,
    private _noteService:  ReservationNoteService,
    private _sweetAlertHelper: SweetAlertHelper
  ) {
    super('app-rider-form', Inject);
  }

  ngOnInit(): void {
    this.callTypes.subscribe(resp => this.selectCallTypes = resp);
    this.valueChanges();
    this.subcriptions();
  }

  subcriptions() {
    this.arraySubscriptions.push(
      this.actionsList$.subscribe(() => {
        this.permissioSsn = {
          showSsn: this.isAllowedAction('ShowSsn'),
          updateSsn: this.isAllowedAction('UpdateSsn')
        };
      }),
      this._noteService.getTypesNotes(NoteTypeEnum.Member).subscribe({
        next: (resp: any) => {
          if (resp && resp.length) {
            this.members = resp;
          }
        },
        error: (err) => {
          this._sweetAlertHelper.captureException(err);
        },
      })
    );
  }

  private getDrivers(providerId: number): void {
    this.selectDrivers = [];
    this.arraySubscriptions.push(
      this._driverService.get(providerId, '', false, 4)
      .subscribe((data) => {
        this.selectDrivers = data;
        }
      )
    );
  }

  private getDepots(providerId): void {
    this.selectDepots = [];
    this.arraySubscriptions.push(
      this._depotService.get(providerId).subscribe((depots) => {
        this.selectDepots = depots;
      })
    );
  }

  private valueChanges(): void {
    this.arraySubscriptions.push(
      this.newReservationService.tabSelected$.subscribe((res) => {
        if (res) {
          this.selectProviders = [];
          switch (res.numberTab) {
            case 1:
              this.userService.getAllProviders().subscribe(
                provs => {
                  this.selectProviders = provs;
                }
              );
              break;
            case 4:
              this.arraySubscriptions.push(
                this.riderInformationForm.get('riderid').valueChanges.subscribe(val => {
                  if (val > 0 && val !== this.riderId) {
                    this.newReservationService.riderSelectedSubject.next({ id: val });
                    this.riderId = val;
                    this.userService.getAllProvidersByRider(val).subscribe(
                      provs => {
                        this.selectProviders = provs;
                      }
                    );
                  }
                })
              );
              break;
            default:
              break;
          }
        }

        this.arraySubscriptions.push(
          this.riderInformationForm.get('providerid').valueChanges.subscribe(val => {
            if (val > 0 && val !== this.providerId) {
              this.providerId = val;
              this.getDepots(val);
              this.getDrivers(val);
              this.newReservationService.providerSelectedSubject.next({ id: val });
            } else {
              if (val === null) {
                this.providerId = null;
                this.newReservationService.providerSelectedSubject.next({ id: null });
              }
            }
          })
        );
      })
    );

    this.arraySubscriptions.push(
      this.riderInformationForm.get('ssn').valueChanges.subscribe((val) => {
        if (val && (val.replace(/\D/g, '').length !== 9)) {
          const split = val.split('-');
          if (split[0] !== 'XXX') {
            this.riderInformationForm.controls['ssn'].setErrors({ 'incorrect': true });
          }
        }
      })
    );
  }

  cleanSelected(): void {
    this.riderInformationForm.get('driverid').setValue('');
    this.riderInformationForm.get('depotid').setValue('');

    if (this.riderInformationForm.get('providerid').value === null) {
      this.newReservationService.providerSelectedSubject.next({ id: null });
    }
  }

  onReload(): void {
    this.reload.emit(true);
  }

  get isInactive(): boolean {
    return this.riderInformationForm.get('isinactive').value;
  }

  get showVerifiedLabel(): boolean {
    return !!this.riderInformationForm.get('riderid').value &&
      this.riderInformationForm.get('email').value &&
      this.riderInformationForm.get('ivrstatus').value === IvrStatusEnum.OPT_IN;
  }

  get emailVerifiedMessage(): string {
    return this.riderInformationForm.get('emailverified').value ? 'verified email' : 'unverified email';
  }

  get isEmailVErified(): boolean {
    return this.riderInformationForm.get('emailverified').value;
  }

  openModalExcludeProvier(): void {
    if (this.isAllowedAction('ExcludeProvider') && this.riderInformationForm.get('riderid').value) {
      this.ridermodal.open();
    }
  }

  emitterActionCard(event: { isOpen: boolean, isMinimized: boolean }): any {
    if (!event.isOpen) {
      if (this.riderId && this.riderId !== null && this.riderId !== 0) {
        this.newReservationService.riderSelectedSubject.next({ id: this.riderId });
        this.arraySubscriptions.push(
          this.userService.getAllProvidersByRider(this.riderId).subscribe(
            provs => {
              this.selectProviders = provs;
              this.riderInformationForm.get('providerid').patchValue(this.providerId);
            }
          )
        );
      }
    }
  }

  riderModalClose(event: { hasClose: boolean }): void {
    if (event && event.hasClose) {
      this.onReload();
      this.ridermodal.close();
    }
  }

  onChangePhone(event, property: string): void {
    if (event) {
      const phoneValid = event.target.value.replace(/[^0-9]/g, '').length;
      if (phoneValid && phoneValid < 10) {
        this.riderInformationForm.controls[property].setErrors({ 'incorrect': true });
      } else {
        this.riderInformationForm.controls[property].setErrors(null);
      }
    }
  }

  ngOnDestroy(): void {
    if (!!this.arraySubscriptions) {
      this.arraySubscriptions.forEach(value => value.unsubscribe());
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/rider/components/rider-information/rider-information.component.ts